// extracted by mini-css-extract-plugin
export default {"row":"Offer_row__pK-84","offerCard":"Offer_offerCard__rdtTK"};